// Mutation hook - odpiecie oferty od transakcji
// DELETE /api/ui/sales-crm/deals/{dealId}/offers/{offerId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IDeleteDealOfferAssignResponse {
  data?: { success: boolean; dealId: number; offerId: number };
  message?: string;
}

interface IDeleteDealOfferAssignVariables {
  dealId: number;
  offerId: number;
}

const deleteDealOfferAssign = ({
  dealId,
  offerId,
}: IDeleteDealOfferAssignVariables): Promise<IDeleteDealOfferAssignResponse> =>
  axios.delete(`/sales-crm/deals/${dealId}/offers/${offerId}`);

export const useDeleteDealOfferAssign = (
  options?: UseMutationOptions<IDeleteDealOfferAssignResponse, IError, IDeleteDealOfferAssignVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteDealOfferAssignResponse, IError, IDeleteDealOfferAssignVariables>(
    deleteDealOfferAssign,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['sales-crm-deal-offers', variables.dealId]);
        await queryClient.refetchQueries(['sales-crm-deal-offers', variables.dealId]);
        await queryClient.invalidateQueries(['sales-crm-trader-client-offers-simple']);
        options?.onSuccess?.(data, variables, context);
      },
    },
  );
};
